import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import cn from 'classnames';
import LoginButtons from './LoginButtons';
import DonationLabelsForm from './DonationLabelsForm';
import getLocalStorageObject from '../../helpers/getLocalStorageObject';
import theme from '../../styles/theme';

class DonationLabels extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      undeterminedLogin: true,
    };
  }

  static getInitialState() {
    const tiAuth = getLocalStorageObject('ngStorage-ti_auth');

    return {
      loggedIn: tiAuth && !tiAuth.isGuest,
      undeterminedLogin: tiAuth === undefined,
    };
  }

  componentDidMount() {
    const { loggedIn, undeterminedLogin } = DonationLabels.getInitialState();

    this.setState({
      loggedIn,
      undeterminedLogin,
    });
  }

  render() {
    const { classes } = this.props;
    const { loggedIn, undeterminedLogin } = this.state;

    if (undeterminedLogin && loggedIn !== undefined) {
      return null;
    }

    return (
      <div className={cn(classes.donationLabels)}>
        <div className={cn(classes.title)}>
          Download your free clothing donation postage label here!
        </div>
        {loggedIn
          ? <DonationLabelsForm classes={classes} />
          : <LoginButtons classes={classes} />}
      </div>
    );
  }
}

DonationLabels.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default injectSheet({
  donationLabels: {
    textAlign: 'center',
    padding: 20,
    color: theme.colors.brandBlack,
  },
  donationLabelsSpacer: {
    maxWidth: 600,
    margin: 'auto',
    padding: 20,
  },
  title: {
    fontSize: 26,
    fontWeight: 'bold',
    letterSpacing: 0.3,
  },
  subtitle: {
    marginBottom: 20,
  },
  nameContainer: {
    '& > :first-child': {
      marginBottom: 8,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
  },
})(DonationLabels);
